<!--
Author: jiangli
Date: 2024-05-08
Desc: 定投计算器
 -->
<template>
    <div>
        <div class="bor_E4E4E4 pl20 pr20 pb20">
            <div class="fs20 c_333 pt16 pb20">定投计算器</div>
            <div class="bor_t_E4E4E4 mb30">
                <el-form
                    ref="planCalculator"
                    :model="fundInfo"
                    :rules="rules"
                    label-position="right"
                >
                    <div class="flex between">
                        <div>
                            <el-form-item label="定投方式：" prop="plantype">
                                <el-radio-group v-model="fundInfo.plantype">
                                    <el-radio label="1">定期定额</el-radio>
                                    <el-radio label="0">定期不定额</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="开始日期：" prop="begindate">
                                <date-picker
                                    :date="dateSet1"
                                    style="width: 400px"
                                    v-on:date-get="dateInterval($event, 'begindate')"
                                />
                            </el-form-item>
                            <el-form-item label="赎回日期：" prop="enddate">
                                <date-picker
                                    :date="dateSet2"
                                    v-on:date-get="dateInterval($event, 'enddate')"
                                />
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="指数类型："
                                prop="indextype"
                            >
                                <el-select v-model="fundInfo.indextype">
                                    <el-option
                                        v-for="(item, index) in $cache.getDict('130050')"
                                        :key="index"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="均线类型："
                                prop="averagetype"
                            >
                                <el-select v-model="fundInfo.averagetype">
                                    <el-option
                                        v-for="(item, index) in $cache.getDict('210312')"
                                        :key="index"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="级差："
                                prop="floatratio"
                            >
                                <el-select v-model="fundInfo.floatratio">
                                    <el-option label="10%" value="0.1"></el-option>
                                    <el-option label="20%" value="0.2"></el-option>
                                    <el-option label="30%" value="0.3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="分红方式："
                                prop="defdividendmethod"
                            >
                                <el-radio-group v-model="fundInfo.defdividendmethod">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('110001')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="定投基金：" prop="fundcode">
                                <el-select v-model="fundInfo.fundcode" filterable>
                                    <el-option
                                        v-for="(item, index) in funds"
                                        :key="index"
                                        :label="'[' + item.fundcode + ']' + item.fundname"
                                        :value="item.fundcode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="定投金额：" prop="appamount">
                                <el-input v-model="fundInfo.appamount"></el-input>
                            </el-form-item>
                            <div class="flex between w485">
                                <el-form-item label="定投费率：" class="rate" prop="planfee">
                                    <div class="flex hcenter bor_D9D9D9 pt12 pb12 pl13 pr13">
                                        <input
                                            v-model="fundInfo.planfee"
                                            type="text"
                                            class="w36 bor_none c_999 outline_none w103"
                                        />
                                        <span>%</span>
                                    </div>
                                </el-form-item>
                                <el-form-item label="赎回费率：" class="rate" prop="redeemfeee">
                                    <div class="flex hcenter bor_D9D9D9 pt12 pb12 pl13 pr13">
                                        <input
                                            v-model="fundInfo.redeemfeee"
                                            type="text"
                                            class="w36 bor_none c_999 outline_none w103"
                                        />
                                        <span>%</span>
                                    </div>
                                </el-form-item>
                            </div>
                            <el-form-item
                                v-if="fundInfo.plantype === '1'"
                                label="收费方式："
                                prop="transfeetype"
                            >
                                <el-radio-group v-model="fundInfo.transfeetype">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('220040')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="分红方式："
                                prop="defdividendmethod"
                            >
                                <el-radio-group v-model="fundInfo.defdividendmethod">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('110001')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="购买方式："
                                prop="sharetype"
                            >
                                <el-radio-group v-model="fundInfo.sharetype">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('130000')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                v-if="fundInfo.plantype === '0'"
                                label="净申购额："
                                prop="transfeetype"
                            >
                                <el-radio-group v-model="fundInfo.transfeetype">
                                    <el-radio
                                        v-for="(item, index) in $cache.getDict('220040')"
                                        :key="index"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="flex">
                    <el-button type="primary" class="medium m-auto" v-on:click="valid">
                        计算收益
                    </el-button>
                </div>
            </div>
            <div v-if="searched" class="bc_FBFBFB pt20 pl20 pr20">
                <!--第一个表格start-->
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666 bc_FCFAE8">
                    <div class="flex1 pl16">投入本金</div>
                    <div class="flex1 txt-c">定投日期</div>
                    <div class="flex1 txt-c">当日净值</div>
                    <div class="flex1 txt-c">购得份额</div>
                    <div class="flex1 txt-c">累计份额</div>
                    <div class="flex1 txt-c">累计收益率</div>
                </div>
                <div v-if="tableData1.length > 0">
                    <div
                        v-for="(item, index) in tableData1"
                        :key="index"
                        class="flex c_666666 pt27 pb27 bc_ffffff bor_b_F1F1F1"
                    >
                        <div class="flex1 pl16">{{ item.amount || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.plandate || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.nav || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.confirmvol || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.totalvol || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.floatratio || "--" }}</div>
                    </div>
                </div>
                <div v-else class="pt27 pb27 txt-c bc_ffffff bor_F1F1F1 c_999">
                    目前还没有，晚点再看看
                </div>
                <div class="bc_ffffff bor_F1F1F1 flex txt-c">
                    <div class="flex1 bor_r_F1F1F1 pt16 pb16">
                        <div class="c_999">扣款次数</div>
                        <div class="fs18 mt8 bold">{{ calInfo.totaltimes || "--" }}</div>
                    </div>
                    <div class="flex1 bor_r_F1F1F1 pt16 pb16">
                        <div class="c_999">累计投入金额(元)</div>
                        <div class="fs18 mt8 c_EA0000">{{ calInfo.totalamount || "--" }}</div>
                    </div>
                    <div class="flex1 pt16 pb16">
                        <div class="c_999">平均成本(元)</div>
                        <div class="fs18 mt8 c_EA0000">{{ calInfo.avgcostmoney || "--" }}</div>
                    </div>
                </div>
                <!--第一个表格end-->

                <!--第二个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">赎回汇总</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">当日市值(元)</div>
                    <div class="flex1 txt-c">赎回日期</div>
                    <div class="flex1 txt-c">赎回价格(元)</div>
                    <div class="flex1 txt-c">购得份额(份)</div>
                    <div class="flex1 txt-c">赎回费用(元)</div>
                </div>
                <div class="bor_F1F1F1 flex c_666666 pt27 pb27 bc_ffffff">
                    <div class="flex1 pl16">{{ calInfo.redeemmarket || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.redeemdate || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.redeemprice || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.redeemconfirmvol || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.redeemcharge || "--" }}</div>
                </div>
                <!--第二个表格end-->

                <!--第三个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">收益汇总</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">赎回所得(元)</div>
                    <div class="flex1 txt-c">累计红利(元)</div>
                    <div class="flex1 txt-c">累计转投(元)</div>
                    <div class="flex1 txt-c">定投总收益(份)</div>
                    <div class="flex1 txt-c">定投总收益率</div>
                </div>
                <div class="bor_F1F1F1 flex c_666666 pt27 pb27 bc_ffffff">
                    <div class="flex1 pl16">{{ calInfo.redeemprice || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.totaldividend || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.totaldividendvol || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.totalprofit || "--" }}</div>
                    <div class="flex1 txt-c">{{ calInfo.totalincomeratio || "--" }}</div>
                </div>
                <!--第三个表格end-->

                <!--第四个表格start-->
                <div class="flex hcenter mt40 mb20">
                    <div class="w3-7r h16 bc_E60012 mr6"></div>
                    <div class="fs18">分红拆分明细</div>
                </div>
                <div class="bor_F1F1F1 flex pt18 pb18 c_666666">
                    <div class="flex1 pl16">日期</div>
                    <div class="flex1 txt-c">分红或拆分比例</div>
                    <div class="flex1 txt-c">参与份额(份)</div>
                    <div class="flex1 txt-c">现金分红(元)</div>
                    <div class="flex1 txt-c">转投(份)</div>
                </div>
                <div v-if="tableData2.length > 0">
                    <div
                        v-for="(item, index) in tableData2"
                        :key="index"
                        class="flex c_666666 pt27 pb27 bc_ffffff bor_b_F1F1F1"
                    >
                        <div class="flex1 pl16">{{ item.dividenddate || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.dividendunit || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.dividendvol || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.dividendamount || "--" }}</div>
                        <div class="flex1 txt-c">{{ item.dividendbuyvol || "--" }}</div>
                    </div>
                </div>
                <div v-else class="pt27 pb27 txt-c bc_ffffff bor_F1F1F1 c_999 flex wcenter">
                    <div class="flex hcenter">
                        <img src="../../assets/img/red-tip.png" class="w16 h16 mr3" />
                        <div class="c_EA0000">未查询到符合条件的数据！</div>
                    </div>
                </div>
                <!--第四个表格end-->

                <div class="flex wcenter mt30">
                    <div
                        class="c_ffffff bc_E60012 pt10 pb10 pl42 pr42 fs16 mb40 pointer"
                        v-on:click="$router.push('gfund/glist')"
                    >
                        立即办理定投
                    </div>
                </div>
            </div>
        </div>
        <footerQuestions
            :common-question="commonQuestion"
            :warning-html="warningHtml"
            class="pl20"
        ></footerQuestions>
    </div>
</template>

<script>
import footerQuestions from "@/components/layout/footerQuestions.vue";
import datePicker from "@/components/form/datePicker";
import fundApi from "@/api/fund";
export default {
    name: "PlanCalculator",
    components: { footerQuestions, datePicker },
    data() {
        return {
            fundInfo: {
                // 入参信息
                plantype: "1",
                begindate: "",
                enddate: "",
                defdividendmethod: "0",
                fundcode: "",
                appamount: "",
                planfee: "",
                redeemfeee: "",
                sharetype: "0",
                indextype: "",
                averagetype: "",
                floatratio: "",
                transfeetype: "0"
            },
            rules: {
                plantype: [{ required: true, message: "请选择定投方式", trigger: "blur" }],
                begindate: [{ required: true, message: "请选择开始日期", trigger: "blur" }],
                enddate: [{ required: true, message: "请选择赎回日期", trigger: "blur" }],
                defdividendmethod: [{ required: true, message: "请选择分红方式", trigger: "blur" }],
                fundcode: [{ required: true, message: "请选择定投基金", trigger: "blur" }],
                appamount: [{ required: true, message: "请输入定投金额", trigger: "blur" }],
                planfee: [{ required: true, message: "请输入定投费率", trigger: "blur" }],
                redeemfeee: [{ required: true, message: "请输入赎回费率", trigger: "blur" }],
                indextype: [{ required: true, message: "请选择指数类型", trigger: "blur" }],
                averagetype: [{ required: true, message: "请选择均线类型", trigger: "blur" }],
                floatratio: [{ required: true, message: "请选择级差", trigger: "blur" }],
                transfeetype: [{ required: true, message: "请选择净申购额", trigger: "blur" }]
            },
            dateSet1: { type: "", min: "1990-01-01" },
            dateSet2: { type: "", min: "1990-01-01" },
            funds: [],
            commonQuestion: [
                {
                    title: "什么是外扣法？",
                    answer:
                        "“外扣法”是证监会要求使用的计算基金申购费用和申购份额的计算方法。外扣法意味着投资者用同样的钱，购买的基金份额将会比内扣法方式购买的多。<br><br>\n" +
                        "                外扣法是针对实际购买金额，即净投资额的。具体计算公式如下：<br>净申购金额＝申购金额/(1＋申购费率)<br>申购费用＝申购金额－净申购金额<br>申购份额＝净申购金额/申购当日基金份额净值。",
                    showFlag: false
                }
            ],
            warningHtml:
                "1、本计算结果仅供参考，并不预示基金将来的收益。投资者不应以网络提供的数据作为基金投资标准。<br>2、大成基金不对计算结果的准确性及完整性负责，也不对使用计算结果引起的后果负任何责任。",
            tableData1: [],
            tableData2: [],
            calInfo: {},
            searched: false
        };
    },

    created() {
        // 获取定投基金
        this.getFunds();
    },

    methods: {
        async getFunds() {
            const _x = {
                pagesize: 999,
                pagenum: 1,
                valuagrbuystate: "1"
            };
            const res = await fundApi.getFundLists(_x);
            if (res.data) {
                this.funds = res.data.list;
            }
        },
        // 方法定义
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        dateInterval(val, key) {
            this.fundInfo[key] = val !== null ? val.replace(/-/g, "") : "";
        },
        async valid() {
            //            this.searched = true; // 临时代码
            //            return; // 临时代码
            this.$refs["planCalculator"].validate((valid) => {
                if (valid) {
                    this.searched = true;
                    this.doCalculate();
                }
            });
        },
        async doCalculate() {
            const res = await fundApi.combCalPlanModle(this.fundInfo);
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form {
    padding: 48px 67px 41px 87px;
    .el-form-item {
        display: flex;
    }
    :deep(.el-date-editor) {
        width: 400px !important;
    }
    :deep(.el-form-item__label) {
        padding-right: 0 !important;
    }
    .rate {
        :deep(.el-form-item__content) {
            width: auto !important;
            line-height: normal !important;
        }
    }
    :deep(.el-form-item__content) {
        width: 400px !important;
    }
    :deep(.el-select) {
        width: 400px !important;
    }
}
.common-question-contain {
    margin: 20px 0;
}
</style>
